import { Header } from './components/Header';
import { InfoSection } from './components/InfoSection';
import { MainContainer } from './components/MainContainer';

function App() {
  return (
    <MainContainer>
      <Header />
      <InfoSection />
    </MainContainer>
  );
}

export default App;
